// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3LwoT","label":"CategoryService_label__5xWOI","location":"CategoryService_location__3oReW"};